/** Maps the two workload kinds to the existing message reliability process names. */
import { AiJobKind, AiJobsReliabilityProcessName } from './ai.jobs.model';

/** Which reliability process carries each job kind. */
export const AI_JOB_PROCESS_BY_KIND: Record<AiJobKind, AiJobsReliabilityProcessName> = {
    'task-validation': AiJobsReliabilityProcessName.TaskValidation,
    'bill-scan': AiJobsReliabilityProcessName.BillScan,
};

/** Which job kind a reliability process name belongs to. */
export const AI_JOB_KIND_BY_PROCESS: Record<AiJobsReliabilityProcessName, AiJobKind> = {
    [AiJobsReliabilityProcessName.TaskValidation]: 'task-validation',
    [AiJobsReliabilityProcessName.BillScan]: 'bill-scan',
};
